import Layout from '../../components/layout/Layout'

const ThoughtMySetup = () => {
  return (
    <Layout>
      <div className="w-full max-w-4xl px-4 md:px-8 lg:px-12 py-12 space-y-6">
        <div className="flex flex-col md:flex-row md:items-baseline gap-2 md:gap-4">
          <h1 className="text-[2.488rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance]">
            My Setup 2025
          </h1>
        </div>
        
        <p className="text-foreground text-[1.375rem] leading-[1.3] [text-wrap:balance]">
          Everything I own and use.
        </p>

        <div className="blog-body space-y-4 text-foreground text-[1.125rem] leading-[1.625] [text-wrap:balance]">
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
            <div className="space-y-8">
              {/* Column 1 */}
              <div>
                <h2 className="text-[1.953rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance] mb-4">
                  Coffee
                </h2>
                <ul className="list-disc pl-6 space-y-2 text-foreground">
                  <li>Fellow Ode Brew Grinder Gen 2 ($300)</li>
                  <li>Fellow Stagg EKG Electric Kettle ($200)</li>
                  <li>Hario V60 Ceramic Coffee Dripper ($25)</li>
                  <li>Hario V60 Paper Coffee Filter ($5)</li>
                  <li>ANY BRAND Double Wall Coffee Mug 12 OZ ($6)</li>
                  <li>Coffe beans 300g/bag ($40)</li>
                </ul>
              </div>

              <div>
                <h2 className="text-[1.953rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance] mb-4">
                  Supplements
                </h2>
                <ul className="list-disc pl-6 space-y-2 text-foreground">
                  <li>Vitamin D3 + K2</li>
                  <li>Magnesium glycinate</li>
                  <li>Fish oil omega-3</li>
                </ul>
              </div>

              <div>
                <h2 className="text-[1.953rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance] mb-4">
                  Electronics
                </h2>
                <ul className="list-disc pl-6 space-y-2 text-foreground">
                  <li>Macbook Pro 16" ($2000) <b>(Every 2 years)</b></li>
                  <li>iPhone 16 Pro ($1000) <b>(Every 2 years)</b></li>
                  <li>
                    Rode AI-Micro Audio Interface ($78){' '}
                    <a 
                      href="https://www.amazon.com/Rode-AI-Micro-Compact-Audio-Interface/dp/B09KZJTW73" 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="text-foreground hover:underline"
                    >
                      <b>(Buy on Amazon)</b>
                    </a>
                  </li>
                  <li>
                    Sony Lavalier Microphone ECMLV1 ($28){' '}
                    <a 
                    // https://www.ebay.com/itm/256721031333?_skw=Sony+ECMCS3&epid=110973642&itmmeta=01JJAQ6WCYTWB5X1ZX3HVA03K2&hash=item3bc5c410a5:g:zM4AAOSwJO1nO6Ik&itmprp=enc%3AAQAJAAAA8HoV3kP08IDx%2BKZ9MfhVJKn1QIrfv%2FF3x%2BPSEmJDTpbukPCUEkWdAjdt%2F6C1zzTYNyfWGd5EttLRoda8niolpT0lbouP8r7QB30vCobihdoHX2AIZSS9C5infJhkcSXoyiZBkaf5%2Fe51b4iyAQ5KRtlne0zSqigW%2FFARxjZWgbFstFY%2Btu13iPldmAS1LURhegiI6pMj6itlvgjwEEMQf85FVTQ%2B78l0rvs5l%2B1Yd4Dy8vzK3k9Vw2u4lBSxGpJn1HnSjS7ieCuMik%2B8RvRADGKhz%2BSxJPcUUBs41retix%2Bp39O8H9VPeAN1t8BQ2WSarw%3D%3D%7Ctkp%3ABk9SR6DHm9eSZQ
                      href="https://www.amazon.com/Sony-Compact-Lavalier-Microphone-ECMLV1/dp/B08YJQXJRM" 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="text-foreground hover:underline"
                    >
                      <b>(Buy on Amazon)</b>
                    </a>
                  </li>
                </ul>
              </div>

              <div>
                <h2 className="text-[1.953rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance] mb-4">
                  Hygiene
                </h2>
                <ul className="list-disc pl-6 space-y-2 text-foreground">
                  <li>Philips Sonicare toothbrush</li>
                  <li>Natural deodorant</li>
                  <li>Face moisturizer with SPF</li>
                </ul>
              </div>
            </div>

            <div className="space-y-8">
              {/* Column 2 */}
              <div>
                <h2 className="text-[1.953rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance] mb-4">
                  Writing
                </h2>
                <ul className="list-disc pl-6 space-y-2 text-foreground">
                  <li>Remarkable 2 tablet</li>
                  <li>Baron Fig Confidant notebook</li>
                  <li>Pilot V7 precision pens</li>
                </ul>
              </div>

              <div>
                <h2 className="text-[1.953rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance] mb-4">
                  Travel
                </h2>
                <ul className="list-disc pl-6 space-y-2 text-foreground">
                  <li>Peak Design Travel Backpack</li>
                  <li>Packing cubes set</li>
                  <li>International power adapter</li>
                </ul>
              </div>

              <div>
                <h2 className="text-[1.953rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance] mb-4">
                  Home
                </h2>
                <ul className="list-disc pl-6 space-y-2 text-foreground">
                  <li>Philips Hue smart lights</li>
                  <li>Dyson air purifier</li>
                  <li>Standing desk</li>
                </ul>
              </div>

              <div>
                <h2 className="text-[1.953rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance] mb-4">
                  Health
                </h2>
                <ul className="list-disc pl-6 space-y-2 text-foreground">
                  <li>Oura Ring sleep tracker</li>
                  <li>Foam roller</li>
                  <li>Meditation cushion</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default ThoughtMySetup 